import backofficeApi from "../../gateways/backoffice-api";
import moment from 'moment'
import router from '../../routes/index'

const state = {
    user: null,
    logged: !!localStorage.getItem('token_backoffice')
}

const getters = {
    isLogged_backoffice: state => state.logged,
}

const mutations = {
    SET_USER_BACKOFFICE (state, user) {
        state.user = user
    },
    LOGIN_BACKOFFICE(state, data) {
        state.logged = true
        localStorage.setItem('token_backoffice', data.access_token)
        localStorage.setItem('userId_backoffice', data.user.id)
        localStorage.setItem('expiresAt_backoffice', moment().add(data.expires_in, 'seconds').format())
        backofficeApi.defaults.headers.common['Authorization'] = 'Bearer ' + data.access_token
        backofficeApi.defaults.headers['Authorization'] = 'Bearer ' + data.access_token
    },
    LOGOUT_BACKOFFICE(state) {
        state.logged = false
        state.user = null
        localStorage.removeItem('token_backoffice')
        localStorage.removeItem('userId_backoffice')
        localStorage.removeItem('expiresAt_backoffice')
        delete backofficeApi.defaults.headers.common['Authorization']
        delete backofficeApi.defaults.headers.Authorization
    }
}

const actions = {
    FETCH_USER_BACKOFFICE ({ commit }) {
        return backofficeApi.get('/catering/me')
            .then(({ data }) => {
                commit('SET_USER_BACKOFFICE', data.data)
                return data.data
            })
            .catch(error => {
                return Promise.reject(error)
            })
    },
    LOGIN_BACKOFFICE ({ commit, dispatch }, data) {
        commit('LOGIN_BACKOFFICE', data)
        dispatch('FETCH_USER_BACKOFFICE')
    },
    LOGOUT_BACKOFFICE ({ commit }) {
        commit('LOGOUT_BACKOFFICE')
        router.push({name: 'login'})
    }
}

export default {
    state,
    mutations,
    getters,
    actions
}
